__turbopack_context__.v({
  "isActive": "rZ5e-q_isActive",
  "typeOfListView": "rZ5e-q_typeOfListView",
  "typeOfListViewButton": "rZ5e-q_typeOfListViewButton",
  "typeOfListViewIcon": "rZ5e-q_typeOfListViewIcon",
});
